import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import { useTranslation } from "react-i18next";

const OperatorChecklistConfirmForm = (props) => {
 
  const { t } = useTranslation();
 
  const handleConfirm = (event) => {
      event.preventDefault();
      event.stopPropagation();
      props.onConfirm();
  };

  const handleCancel = () => {
    props.onHide();
  };

  const { show, onHide } = props;
  return (
    <>
      <Modal show={show} onHide={onHide} animation={false} backdrop="static">
        <ModalHeader
          title={t("msg_trasaction.msg_operator_checklist.confirm_operator_checklist")}
        ></ModalHeader>
         <Modal.Body>
        <p>
        {t("msg_trasaction.msg_operator_checklist.confirm_operator_checklist_msg")}
        </p>
      </Modal.Body>
        <ModalFooter>
          <Button
            type="button"
            variant="success"
            className="btn btn-success"
            onClick={handleConfirm}
          >
            {t("msg_common.confirm")}
          </Button>
          <Button
            type="button"
            variant="danger"
            className="btn btn-danger"
            onClick={handleCancel}
            data-dismiss="modal"
          >
            {t("msg_common.cancel")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default OperatorChecklistConfirmForm;
